import React, { useContext } from "react";
import * as styles from "./style.mod.scss";
import FacebookIcon from "assets/images/account/facebook-icon.svg";
import MessengerIcon from "assets/images/account/messenger-icon.svg";
import { ChevronRight, Clipboard } from "react-bootstrap-icons";
import GlobalContext from "services/global-context";
import { Container } from "react-bootstrap";
import Highlights from "components/highlights";
import Image from "components/image";
import locale from "locales";

const InviteFriends = ({ data }) => {
  const { setCurrentPanel } = useContext(GlobalContext);
  
  const handleLogin = () => {
    setCurrentPanel("login");
    return false;
  };
  return (
    <div className={styles.inviteFriends}>
      <Container>
        <div className={styles.inviteFriendsContainer}>
          <div className={styles.bannerWrap}>
            <Image image={data?.image} alt={data?.image?.alt}/>
          </div>
          <div className={styles.bannerCopy}>
            <h1 className={styles.bannerCopyTitle}>{data?.title}</h1>
            <p className={styles.bannerCopyDescription}>{data?.description}</p>
            <Highlights />
            <ul>
              <li>
                <a href="#" onClick={handleLogin}>
                  <div>
                    <i className="bi bi-envelope" />  <span>Email</span>
                  </div>
                  <span><ChevronRight /></span>
                </a>
              </li>
              <li>
                <a href="#" onClick={handleLogin}>
                  <div>
                    <i className="bi bi-whatsapp" />  <span>WhatsApp</span>
                  </div>
                  <span><ChevronRight /></span>
                </a>
              </li>
              <li>
                <a href="#" onClick={handleLogin}>
                  <div>
                    <img src={MessengerIcon} alt={locale.altText.messengerIcon} />  <span>Facebook Messenger</span>
                  </div>
                  <span><ChevronRight /></span>
                </a>
              </li>
              <li>
                <a href="#" onClick={handleLogin}>
                  <div>
                    <img src={FacebookIcon} className={styles.facebook} alt={locale.altText.facebookIcon}/>  <span>Facebook</span>
                  </div>
                  <span><ChevronRight /></span>
                </a>
              </li>
              <li className={styles.copied ? styles.linkCopied : ""}>
                <a href="#" onClick={handleLogin}>
                  <div>
                    <i className="bi bi-link-45deg" />  <span>{styles.copied ? "Link kopiert!" : "Link kopieren"}</span>
                  </div>
                  <span><Clipboard /></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </div>     
  );
};

export default InviteFriends;